import { render, staticRenderFns } from "./SalarySettlementsLatest.vue?vue&type=template&id=99f79ef0"
import script from "./SalarySettlementsLatest.vue?vue&type=script&lang=js"
export * from "./SalarySettlementsLatest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports